<template>
  <div class="app-auth-sign-in align-content-stretch d-flex flex-wrap justify-content-end">
    <div class="app-auth-background"><img>
    </div>
    <form @submit.prevent="submit" class="app-auth-container">
      <div class="logo">
          <img src="../../assets/images/logo-salvando-arvores2.png" alt="Salvando Árvores da Extinção" width="215"/>
      </div>
      <p class="auth-description">{{ $t('label.porfavorfacaloginparaacessaroadmin') }}</p>
      <div class="d-flex gap-3 mt-3">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio1"
            :value="false"
            v-model="form.fromApp"
          >
          <label class="form-check-label" for="inlineRadio1">
            {{ $t('label.email') }}
          </label>
        </div>

        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio2"
            :value="true"
            v-model="form.fromApp"
          >
          <label class="form-check-label" for="inlineRadio2">
            {{ $t('label.telefone') }}
          </label>
        </div>
      </div>
      <div class="auth-credentials m-b-xxl">
          <template v-if="form.fromApp">
            <label for="signInPhone" class="form-label mt-2">{{ $t('label.telefone') }}</label>
            <vue-tel-input class="tel-input mb-2" v-model="form.phone" :class="{ 'is-invalid': v$.form.phone.$dirty && v$.form.phone.$error }"></vue-tel-input>
            <div class="invalid-feedback">
              {{ $t('message.requiredField') }}
            </div>
          </template>
          <template v-else>
            <label for="signInEmail" class="form-label mt-2">{{ $t('label.email') }}</label>
            <input type="email" class="form-control mb-2" id="signInEmail" aria-describedby="signInEmail" v-model="form.login"
              :class="{ 'is-invalid': v$.form.login.$dirty && v$.form.login.$error }">
              <div class="invalid-feedback">
                {{ $t('message.requiredField') }}
              </div>
          </template>
          <label for="signInPassword" class="form-label mt-0">{{ $t('label.senha') }}</label>
          <input type="password" class="form-control" id="signInPassword" aria-describedby="signInPassword" v-model="form.password"
            :class="{ 'is-invalid': v$.form.password.$dirty && v$.form.password.$error }">
            <div class="invalid-feedback">
              {{ $t('message.requiredField') }}
            </div>
      </div>
      <div class="auth-submit">
          <button type="submit" class="btn btn-primary">{{ $t('label.acessar') }}</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import useVuelidate from '@vuelidate/core'
import { email, required } from '@vuelidate/validators'
export default {
  name: 'LoginView',
  setup: () => ({ v$: useVuelidate() }),
  data: () => ({
    form: {
      login: '',
      password: '',
      phone: '',
      fromApp: false
    }
  }),
  validations () {
    return {
      form: {
        login: {
          validLogin (value) {
            if (!this.form.fromApp && !value) {
              return false
            }
            return true
          },
          email
        },
        password: { required },
        phone: {
          validPhone (value) {
            if (this.form.fromApp && !value) {
              return false
            }
            return true
          }
        }
      }
    }
  },
  watch: {
    'form.fromApp' () {
      this.form.login = ''
    }
  },
  methods: {
    submit () {
      this.v$.$touch()
      if (this.v$.form.$invalid === false) {
        if (this.form.fromApp) {
          this.form.login = this.form.phone
        }
        axios.post('/login', this.form).then(response => {
          if (response.data.token) {
            this.$store.commit('setUser', response.data)
            this.$router.push('/')
          }
        })
      }
    }
  }
}
</script>
